import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { Compass, Home, ArrowLeft } from "lucide-react";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-[75vh] w-full flex items-center justify-center bg-gray-50 px-4 py-16">
      <div className="max-w-xl w-full text-center bg-white p-8 sm:p-14 rounded-3xl shadow-xl border border-gray-100 relative overflow-hidden my-8">
        {/* Ambient background accent blurs */}
        <div className="absolute -top-20 -left-20 w-44 h-44 bg-purple-200 rounded-full blur-3xl opacity-70 pointer-events-none" />
        <div className="absolute -bottom-20 -right-20 w-44 h-44 bg-purple-300 rounded-full blur-3xl opacity-50 pointer-events-none" />

        <div className="relative z-10 flex flex-col items-center">
          {/* Compass Icon Badge */}
          <div className="w-20 h-20 bg-purple-100 rounded-2xl flex items-center justify-center text-purple-600 mb-6 shadow-sm border border-purple-200">
            <Compass className="w-10 h-10 animate-pulse" />
          </div>

          <h1 className="text-6xl sm:text-7xl font-extrabold text-gray-900 tracking-tight mb-2">
            404
          </h1>

          <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4">
            Page Not Found
          </h2>

          <p className="text-gray-600 text-base sm:text-lg max-w-md mb-8 leading-relaxed">
            We couldn't find the page you were looking for. It might have been moved or doesn't exist anymore.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 w-full">
            <button
              onClick={() => navigate(-1)}
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-lg border border-gray-300 text-gray-700 font-bold hover:bg-gray-100 transition-all shadow-sm cursor-pointer"
            >
              <ArrowLeft className="w-4 h-4" />
              Go Back
            </button>

            <Link
              to="/"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-lg bg-purple-600 hover:bg-black text-white font-bold transition-all shadow-md hover:scale-105 cursor-pointer"
            >
              <Home className="w-4 h-4" />
              Back to Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
